import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomFamiliesListState, StateWithFamilies } from '../custom-families-state';
import { getFamiliesListState } from './feature-selector';

export const getAllFamiliesListState: MemoizedSelector<
  StateWithFamilies,
  any[]
> = createSelector(
  getFamiliesListState,
  (state: CustomFamiliesListState) => state?.families
);


